import type { ContractorTranslation } from './en';

export const id: ContractorTranslation = {
  common: {
    cancel: 'Batal',
    save: 'Simpan',
    retry: 'Coba lagi',
    download: 'Unduh',
    continue: 'Lanjutkan',
    yes: 'Ya',
    no: 'Tidak',
    genericError: 'Terjadi kesalahan. Silakan coba lagi.',
    networkError: 'Tidak dapat terhubung ke DubForge. Periksa koneksi internet Anda.',
  },
  app: {
    tagline: 'Tugas sulih suara, file, dan peninjauan di satu tempat.',
    startupFailed: 'DubForge tidak dapat dimulai',
    notFoundTitle: 'Halaman tidak ditemukan',
    notFoundBody: 'Halaman itu tidak ada, atau Anda tidak memiliki akses ke halaman tersebut.',
    goHome: 'Ke beranda',
    crashTitle: 'Terjadi kesalahan',
    crashBody: 'Coba muat ulang halaman.',
    reload: 'Muat ulang',
  },
  language: {
    label: 'Bahasa',
    change: 'Ganti bahasa',
  },
  welcome: {
    title: 'Selamat datang di DubForge',
    body: 'Pilih bahasa Anda. DubForge dan notifikasi Discord Anda akan menggunakan bahasa ini.',
    changeLater: 'Anda dapat mengubahnya kapan saja melalui menu bahasa di kanan atas.',
  },
  nav: {
    myAssignments: 'Tugas saya',
    openMenu: 'Buka menu',
    account: 'Akun',
    notificationEmail: 'Email notifikasi',
    signOut: 'Keluar',
    roleAdmin: 'Admin',
    roleContractor: 'Pengisi suara',
    lightMode: 'Mode terang',
    darkMode: 'Mode gelap',
  },
  login: {
    signIn: 'Masuk dengan Discord',
    onlyInvited: 'Hanya akun Discord yang ditambahkan oleh pemilik channel yang dapat masuk.',
    signingIn: 'Sedang masuk…',
    backToSignIn: 'Kembali ke halaman masuk',
    failed: 'Gagal masuk. Silakan coba lagi.',
  },
  authErrors: {
    not_invited: 'Akun Discord ini belum ditambahkan ke DubForge. Minta pemilik channel untuk menambahkan Anda.',
    access_off: 'Akses Anda ke DubForge telah dinonaktifkan.',
    discord_only: 'Anda hanya dapat masuk dengan Discord.',
  },
  errors: {
    not_signed_in: 'Sesi Anda telah berakhir. Silakan masuk lagi.',
    access_off: 'Akses Anda ke DubForge telah dinonaktifkan.',
    admins_only: 'Anda tidak memiliki izin untuk melakukan itu.',
    not_found: 'Item tersebut tidak ada atau sudah tidak tersedia.',
    invalid_request: 'Ada yang tidak valid dalam permintaan itu. Periksa lalu coba lagi.',
    conflict: 'Item itu sudah ada.',
    already_approved: 'Tugas ini sudah disetujui, jadi tidak perlu mengunggah lagi.',
    not_audio: 'Hanya file WAV atau MP3 yang dapat diunggah. Unggah hanya trek suara Anda.',
    upload_incomplete: 'Unggahan tidak selesai. Silakan coba lagi.',
    discord_unreachable: 'Tidak dapat terhubung ke Discord. Silakan coba lagi nanti.',
    server_error: 'Terjadi kesalahan di pihak kami. Silakan coba lagi.',
  },
  notifications: {
    title: 'Notifikasi',
    openWithCount: 'Notifikasi ({{count}} belum dibaca)',
    markAllRead: 'Tandai semua sudah dibaca',
    empty: 'Belum ada apa-apa.',
  },
  emailSettings: {
    body: 'Kami mengirim email saat Anda mendapat tugas baru dan saat pekerjaan Anda selesai ditinjau.',
    label: 'Alamat email',
    fromDiscord: 'Diambil dari akun Discord Anda. Ubah jika Anda ingin memakai alamat lain.',
    saved: 'Alamat email disimpan',
    invalid: 'Masukkan alamat email yang valid.',
    missing: 'Belum ada alamat email. Tambahkan untuk menerima notifikasi.',
  },
  status: {
    Assigned: 'Ditugaskan',
    InProgress: 'Sedang dikerjakan',
    Submitted: 'Menunggu peninjauan',
    ChangesRequested: 'Perlu revisi',
    Approved: 'Disetujui',
  },
  assetKind: {
    package: 'Paket sulih suara (video + suara + SFX)',
    video: 'Video referensi (720p)',
    sfx: 'Trek SFX / musik',
    voice: 'Trek suara asli',
    script: 'Naskah',
    other: 'Lainnya',
  },
  translation: {
    machine: 'Diterjemahkan mesin',
    showOriginal: 'Lihat asli',
    showTranslation: 'Lihat terjemahan',
  },
  uploader: {
    progress: '{{percent}}% dari {{size}}',
    queued: 'Menunggu diunggah: {{count}}',
    keepOpen: 'Biarkan tab ini tetap terbuka sampai selesai.',
    cancelled: 'Unggahan dibatalkan',
    done: '{{name}} berhasil diunggah',
    failed: 'Gagal mengunggah: {{error}}',
  },
  my: {
    greeting: 'Halo, {{name}}',
    subtitle: 'Tugas sulih suara Anda.',
    emptyTitle: 'Belum ada tugas',
    emptyBody: 'Saat Anda mendapat video, Anda akan menerima pesan di Discord dan tugasnya akan muncul di sini.',
    todo: 'Perlu dikerjakan',
    waiting: 'Menunggu peninjauan',
    done: 'Selesai',
    updated: 'Diperbarui {{when}}',
  },
  assignment: {
    back: 'Tugas saya',
    dubIn: 'Sulih suara: {{language}}',
    paid: 'Sudah dibayar',
    next: {
      Assigned: 'Unduh file sumber, rekam suara Anda, lalu unggah trek suara Anda di sini.',
      InProgress: 'Jika trek suara Anda sudah siap, unggah di bawah.',
      Submitted: 'Sulih suara Anda sudah dikirim untuk ditinjau. Anda akan menerima pesan di Discord setelah ditinjau.',
      ChangesRequested: 'Ada permintaan revisi. Baca masukan di bawah, lalu unggah versi baru.',
      Approved: 'Disetujui. Terima kasih!',
    },
    notes: 'Catatan',
    sourceFiles: 'File sumber',
    noFiles: 'Belum ada file yang diunggah.',
    fileInfo: '{{kind}} · {{size}}',
    packageHint: 'Satu file .mp4 berisi video dan dua trek audio: trek 1 berisi dialog asli, trek 2 berisi SFX.',
    uploadTitle: 'Unggah trek suara Anda',
    voiceOnlyTitle: 'Hanya suara Anda',
    voiceOnlyBody:
      'Unggah hanya suara yang Anda rekam: tanpa musik, tanpa efek suara, dan tanpa bagian apa pun dari audio asli. Pastikan durasinya sama dengan aslinya.',
    voiceOnlyConfirm: 'File ini hanya berisi dialog suara.',
    dropLabel: 'Unggah trek suara di sini',
    dropHint: 'Hanya WAV atau MP3.',
    noteForReviewer: 'Catatan untuk peninjau (opsional)',
    lengthTitle: 'Durasinya tidak cocok',
    lengthBody:
      'Durasi file Anda {{dub}}, tetapi trek SFX berdurasi {{sfx}}. Jika trek Anda dimulai di titik yang berbeda atau terpotong, trek tidak akan pas dengan video. Tetap unggah?',
    uploadAnyway: 'Tetap unggah',
    chooseAnother: 'Pilih file lain',
    versions: 'Versi yang diunggah',
    nothingUploaded: 'Belum ada yang diunggah.',
    version: 'Versi {{version}}',
    reviewApproved: 'Disetujui',
    reviewChanges: 'Perlu revisi',
    reviewPending: 'Menunggu peninjauan',
    yourNote: 'Catatan Anda:',
    feedback: 'Masukan',
    listen: 'Dengarkan',
    uploadedOn: '{{date}} · {{size}}',
    length: 'Durasi: {{duration}}',
  },
};
